(function () {
  // This section is grid-based (no Swiper needed).
  // Keep file to match your theme pattern + future enhancements.
  const init = () => {};

  init();

  document.addEventListener("shopify:section:load", function () {
    init();
  });
})();